export default "__VITE_ASSET__cfCoAPno__"